import FlagProvider, { IConfig, useFlagsStatus } from '@unleash/proxy-client-react';
import { FC } from 'react';
import {
  ApplicationConfigurationKeyEnum,
  ApplicationConfigurationService,
} from '../application-configuration';

const UNLEASH_PROJECT_NAME: string = 'default';
const FLAG_REQUEST_INTERVAL: number = 30;

const FlagsAwaiterComponent: FC = ({ children }) => {
  const { flagsReady, flagsError } = useFlagsStatus();

  if (flagsReady || flagsError) {
    return <>{children}</>;
  }

  return <></>;
};

const FlagsWithContextProvider: FC = ({ children }) => {
  const {
    FLAG_ENV = 'development',
    FLAG_KEY = '',
    FLAG_URL = '',
  } = ApplicationConfigurationService.getValues([
    ApplicationConfigurationKeyEnum.flagEnv,
    ApplicationConfigurationKeyEnum.flagKey,
    ApplicationConfigurationKeyEnum.flagUrl,
  ]);

  const unleashConfiguration: IConfig = {
    url: FLAG_URL,
    clientKey: FLAG_KEY,
    refreshInterval: FLAG_REQUEST_INTERVAL,
    appName: UNLEASH_PROJECT_NAME,
    environment: FLAG_ENV,
  };

  return (
    <FlagProvider config={unleashConfiguration}>
      <FlagsAwaiterComponent>{children}</FlagsAwaiterComponent>
    </FlagProvider>
  );
};

export default FlagsWithContextProvider;
